export enum PersonaFieldTypes {
  FULLNAME = 5,
  EMAIL = 3,
  PHONE = 4,
  ORGANIZATION = 32,
  JOB_TITLE = 33,
  GENDER = 24,
  AGE_GROUP = 22,
  COUNTRY = 7,
  PLAIN_TEXT = 1,
  RADIO = 14,
  CHECKBOX = 12,
  NUMERIC = 36,
  URL = 10,
  DATE = 15,
  UPLOAD = 9,
  LINE_SEPARATOR = 39,
  INFORMATION_MESSAGE = 40,
  WARNING_MESSAGE = 41,
  STAR_RATING = 42,
  IDENTITY = 43,
  CITY = 44,
  AI_FACIAL_RECOGNITION = 45
}
